import React, { Component } from 'react';
import styled from 'styled-components';
import supportsPassive from '../utils/supportsPassiveEventListener';
import { withRouter } from 'react-router-dom';

const eventOptions = supportsPassive ? { passive: true } : false;
const TIMEOUT_BEFORE_ADD_SCROLL_LISTENER = 1000;

class CollectionSubMenu extends Component {
  static defaultProps = {
    redirectOnScroll: true,
    redirectTo: '/',
  };

  componentDidMount() {
    if (this.props.redirectOnScroll) {
      setTimeout(() => {
        window.addEventListener('scroll', this.onWindowScrollOnce, eventOptions);
      }, TIMEOUT_BEFORE_ADD_SCROLL_LISTENER)
    }
  }

  componentWillUnmount() {
    if (this.props.redirectOnScroll) {
      window.removeEventListener('scroll', this.onWindowScrollOnce, eventOptions);
    }
  }

  onWindowScrollOnce = () => {
    window.removeEventListener('scroll', this.onWindowScrollOnce, eventOptions);

    this.props.history.push(this.props.redirectTo);
  };

  render() {
    const { children, ...props } = this.props;

    return (
      <Container {...props}>{children}</Container>
    );
  }
}

export default withRouter(CollectionSubMenu);

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  padding: 1.5rem 2.125rem;
  background-color: ${props => props.theme.tertiaryBackgroundColorNegative};
  color: #fff;
`;
